var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"animationElement",staticClass:"fnd-lottie",style:({
    width: ((_vm.$props.width) + "px"),
    height: ((_vm.$props.width) + "px"),
  })})}
var staticRenderFns = []

export { render, staticRenderFns }